<template>
    <div class="lead-public-form p-4" :style="{background:bgColor}">
        <p v-if="success_message" class="text-success text-center mb-3 font-weight-bold">{{ success_message }}</p>
        <p v-if="error_message" class="text-danger text-center mb-3 font-weight-bold">{{ error_message }}</p>

        <b-form @submit.prevent="submit">
            <b-row v-if="template == 1">
                <b-col cols="12">
                    <b-form-group label="Name:" class="font-weight-bold">
                        <b-form-input
                        v-model="form.name"
                        required
                        class="fintos-input"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group label="Contact Number:" class="font-weight-bold">
                        <b-form-input
                        type="text"
                        @keydown="preventNonNumericInput"
                        v-model="form.contact_no"
                        maxlength="17"
                        class="fintos-input"
                        required
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group label="Email Address:" class="font-weight-bold">
                        <b-form-input
                        type="email"
                        v-model="form.email"
                        class="fintos-input"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Message:" class="font-weight-bold">
                        <b-form-textarea
                        v-model="form.message"
                        rows="5"
                        class="fintos-input"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
                <b-col md="4" sm="12" class="mx-auto text-center mt-3">
                    <b-button type="submit" class="btn-fintos-submit w-100 bg-white border-none" :disabled="is_loading || is_incomplete">Submit</b-button>
                </b-col>
            </b-row>
            <b-row v-else-if="template == 2" class="template2">
                <b-col cols="12" md="4" class="mb-md-0 mb-3">
                    <b-form-input
                    placeholder="Name"
                    v-model="form.name"
                    required
                    class="fintos-input"
                    ></b-form-input>
                </b-col>
                <b-col cols="12" md="4" class="mb-md-0 mb-3">
                    <b-form-input
                    placeholder="Contact Number"
                    type="text"
                    @keydown="preventNonNumericInput"
                    v-model="form.contact_no"
                    maxlength="17"
                    class="fintos-input"
                    required
                    ></b-form-input>
                </b-col>
                <b-col cols='12' md="3">
                    <b-button type="submit" class="btn-fintos-submit w-100 bg-white border-none" style="padding:12px" :disabled="is_loading || is_incomplete">Submit</b-button>
                </b-col>
            </b-row>
        </b-form>
    </div>
</template>

<style>
    .fintos-input:focus{
        border: 1px solid #FEDB70
    }
    .template2 input::placeholder{
        font-weight: 500;
        color: #000;
    }
</style>

<script>
import {
        axios,
        services
			} from '@/assets/js/httpImports.js'

export default {
    data() {
        return {
            form:{
                name: '',
                contact_no: '',
                email: '',
                type: '',
                channel_id: '',
                platform_id: '',
                message: '',
                created_by: ''
            },
            is_demo: true,
            success_message: null,
            error_message: null,
            is_loading: false,
            template: 1,
            bgColor: '',
        };
    },
    computed:{
        is_incomplete(){
            return this.form.name === '' || this.form.contact_no === ''
        },
    },
    created() {
        this.template = this.$route.query.template ?? 1
        this.form.channel_id = this.$route.query.channel
        this.form.platform_id = this.$route.query.platform
        this.form.created_by = this.$route.query.user
        this.bgColor = this.$route.query.bgColor ? '#'+this.$route.query.bgColor : '#FFC107'
        if(this.$route.query.demo){
            this.is_demo = this.$route.query.demo === 'true'
        }
    },
    methods: {
        submit(){
            this.success_message = null
            this.error_message = null

            const url = services.lead+'public/leads'
            const app_code = 'sas_v2'
        
            let data = {
                "name": this.form.name,
                "contact_no": this.form.contact_no,
                "email": this.form.email,
                "type": "Company",
                "channel_id": this.form.channel_id,
                "platform_id": this.form.platform_id,
                "message": this.form.message,
                "created_by": this.form.created_by,
                "application_code": app_code,
            }

            this.is_loading = true

            axios.post(url, data)
                .then(res => {
                    this.is_loading = false
                    this.resetForm()
                    this.success_message = 'We have received your message and will get back in touch with you soon!'
                })
                .catch(e => {
                    this.is_loading = false
                    if(e.response.data.message){
                        this.error_message = e.response.data.message
                        return
                    }
                    this.error_message = 'Oops, Something went wrong!'
                })
        },
        resetForm(){
            this.form.name = ''
            this.form.contact_no = ''
            this.form.email = ''
            this.form.message = ''
        },
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46, 67, 86];

                // Allow numeric, punctuation, and navigation keys
            if (keyCode === 8 || keyCode === 37 || keyCode === 38 || keyCode === 39 || keyCode === 40 || currencyRegex.test(keyValue) || allowedKeys.includes(keyCode)) {
                return;
            }

            // Check for Ctrl key status along with 'C' (67) or 'V' (86)
            if ((event.ctrlKey || event.metaKey) && (keyCode === 67 || keyCode === 86)) {
                // Allow Ctrl+C and Ctrl+V
                return;
            }
            
            event.preventDefault();
        },
    }
}
</script>
